module.exports = __webpack_public_path__ + "static/media/ic_hi_b6_fisdom.94245b25.svg";